import { StatusChip, fmtBizDate } from "./closingUi";

const sum = (items, f) => items.reduce((s, c) => s + Math.round((Number(f(c)) || 0) * 100), 0) / 100;

export const ClosingsTable = ({ items, openId, onOpen, money }) => {
  const totals = {
    sale: sum(items, (c) => c.totals.total_sale),
    cash: sum(items, (c) => c.totals.cash_deposit),
    deposit: sum(items, (c) => c.totals.deposit_total),
    customers: items.reduce((s, c) => s + (c.reconciliation?.customer_count || 0), 0),
  };
  const th = "p-3 whitespace-nowrap";
  return (
    <div className="overflow-x-auto rounded-sm" style={{ background: "#fff", border: "1px solid var(--ups-border)" }}>
      <table className="w-full text-[13px]" data-testid="closings-table">
        <thead className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--ups-subtext)]">
          <tr className="border-b border-[color:var(--ups-border)]">
            <th className={`${th} text-left`}>Date</th><th className={`${th} text-left`}>Store</th><th className={`${th} text-left`}>Closed by</th>
            <th className={`${th} text-right`}>Total sale</th><th className={`${th} text-right`}>Cash deposit</th><th className={`${th} text-right`}>Bank deposit</th>
            <th className={`${th} text-right`}>Customers</th><th className={`${th} text-right`}>Avg sale</th><th className={`${th} text-left`}>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map((c) => {
            const rec = c.reconciliation;
            return (
              <tr key={c.id} onClick={() => onOpen(c.id)} className={`border-b border-[color:var(--ups-border)] cursor-pointer hover:bg-[color:var(--ups-muted)] ${openId === c.id ? "bg-[#FFF8E1]" : ""}`}
                data-testid={`closing-row-${c.id}`}>
                <td className="p-3 font-semibold whitespace-nowrap">{fmtBizDate(c.business_date)}</td>
                <td className="p-3">{c.store_name}</td>
                <td className="p-3">{c.closed_by_name}</td>
                <td className="p-3 text-right font-mono">{money(c.totals.total_sale)}</td>
                <td className="p-3 text-right font-mono">{money(c.totals.cash_deposit)}</td>
                <td className="p-3 text-right font-mono">{money(c.totals.deposit_total)}</td>
                <td className="p-3 text-right font-mono" data-testid={`closing-row-customers-${c.id}`}>{rec ? rec.customer_count : "—"}</td>
                <td className="p-3 text-right font-mono" data-testid={`closing-row-avg-${c.id}`}>{rec ? money(rec.average_sale) : "—"}</td>
                <td className="p-3"><StatusChip rec={rec} /></td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="font-bold bg-[color:var(--ups-muted)] border-t-2 border-[color:var(--ups-ink,#111)]" data-testid="closings-summary-row">
            <td className="p-3" colSpan={3}>Month to date · {items.length} day{items.length === 1 ? "" : "s"}</td>
            <td className="p-3 text-right font-mono" data-testid="closings-mtd-sales">{money(totals.sale)}</td>
            <td className="p-3 text-right font-mono" data-testid="closings-mtd-cash">{money(totals.cash)}</td>
            <td className="p-3 text-right font-mono" data-testid="closings-mtd-deposit">{money(totals.deposit)}</td>
            <td className="p-3 text-right font-mono" data-testid="closings-mtd-customers">{totals.customers}</td>
            <td className="p-3" />
            <td className="p-3" />
          </tr>
        </tfoot>
      </table>
    </div>
  );
};
